/**
 * Finds and removes any existing Feefo script tags before re-initialising.
 * This allows the use of multiple Feefo widgets in different components on a page.
 * Also adds a style script to the shadow-dom of each Feefo widget.
 */
import { getAppVariable } from '@white-label-helper/get-app-variable';

export function initFeefoReviews(): void {
  if (!getAppVariable('review_providers[0].is_enabled')) {
    return;
  }
  const merchantId = getAppVariable('review_providers[0].merchant_id');

  // remove existing Feefo script if present
  const scriptTag = document.querySelector(`script[src='https://api.feefo.com/api/javascript/${merchantId}']`);
  scriptTag?.remove();

  // add script to end of doc
  const feefoScript = document.createElement('script');
  feefoScript.setAttribute('src', `https://api.feefo.com/api/javascript/${merchantId}`);
  feefoScript.setAttribute('type', 'text/javascript');
  feefoScript.setAttribute('async', 'true');
  document.body.appendChild(feefoScript);
}

export function updateFeefoStyles(): void {
  if (!getAppVariable('review_providers[0].is_enabled')) {
    return;
  }
  const brandColour = getAppVariable('colours.brand');

  setTimeout(() => {
    document.querySelectorAll('.feefo-product-stars-widget').forEach((item) => {
      const style = document.createElement('style');
      style.innerHTML = `
      .summary-rating {
        pointer-events: none;
      },
      .summary-rating .reviews-count {
        font-weight: bold;
        font-family: var(--font-family), sans-serif;
        font-size: 0.875rem;
        color: rgb(${brandColour.substring(0, brandColour.lastIndexOf(',')) || ''});
      }`;
      if (item.shadowRoot && item.shadowRoot.querySelectorAll('style').length < 1) {
        item.shadowRoot.appendChild(style);
      }
    });
  }, 500);
}
